import { Text, View } from 'react-native'

// styles
import { globalStyles } from '../../../static/styles/global'

type BadgeProps = {
  text: string
  textColor: string
  bgColor: string
}

const Badge = ({ text, textColor, bgColor }: BadgeProps): JSX.Element => {
  return (
    <View style={[globalStyles.badge, { backgroundColor: bgColor }]}>
      <Text style={[globalStyles.badgeText, { color: textColor }]}>{text}</Text>
    </View>
  )
}

export type { BadgeProps }
export { Badge }
